export default __webpack_public_path__ + "static/media/auth-background.be730992.webp";